var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"homePage",attrs:{"id":"app"}},[(!_vm.isTracePage)?_c('Nav'):_vm._e(),_c('router-view'),(!_vm.isTracePage)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }